import { TextFileTitleStyle } from 'page/Application/ProjectRegistration/ProjectRegistrationDetail/styled';
import React, { useMemo } from 'react';
import AntdTable from 'components/AntdTable';
import dayjs from 'dayjs';
import { Tooltip } from 'antd';

const TableListFile = ({ dataRaw, handleDownloadFile }) => {
  const dataSource = useMemo(() => {
    if (!dataRaw && dataRaw?.length === 0) return;
    return dataRaw?.map((item) => ({
      ...item,
      key: item.detailId,
    }));
  }, [dataRaw]);

  const columns = useMemo(() => {
    return [
      {
        title: (
          <Tooltip title={'タイトル'} placement={'topLeft'}>
            <TextFileTitleStyle>タイトル</TextFileTitleStyle>
          </Tooltip>
        ),
        dataIndex: 'detailTitle',
        key: 'detailTitle',
        ellipsis: true,
        width: '30%',
        render: (detailTitle) => (
          <TextFileTitleStyle>
            <Tooltip title={detailTitle} placement={'topLeft'}>
              {detailTitle}
            </Tooltip>
          </TextFileTitleStyle>
        ),
      },
      {
        title: (
          <Tooltip title={'ファイル'} placement={'topLeft'}>
            <TextFileTitleStyle>ファイル</TextFileTitleStyle>
          </Tooltip>
        ),
        dataIndex: 'detailUrl',
        key: 'detailUrl',
        ellipsis: true,
        width: '20%',
        render: (url, record) => (
          <span
            style={{ color: '#7B61FF', cursor: 'pointer' }}
            onClick={() => handleDownloadFile(record.detailId)}
          >
            <Tooltip title={record.fileResponse.fileName} placement={'topLeft'}>
              {record.fileResponse.fileName}
            </Tooltip>
          </span>
        ),
      },
      {
        title: (
          <Tooltip title={'説明'} placement={'topLeft'}>
            <TextFileTitleStyle>説明</TextFileTitleStyle>
          </Tooltip>
        ),
        dataIndex: 'detailExplanation',
        key: 'detailExplanation',
        width: '30%' ,
        render: (detailExplanation) => (
          <TextFileTitleStyle>
            <Tooltip title={detailExplanation} placement={'topLeft'}>
              {detailExplanation}
            </Tooltip>
          </TextFileTitleStyle>
        ),
      },
      {
        title: (
          <Tooltip title={'更新日'} placement={'topLeft'}>
            <TextFileTitleStyle>更新日</TextFileTitleStyle>
          </Tooltip>
        ),
        dataIndex: 'detailDisplayDate',
        key: 'detailDisplayDate',
        width: '20%',
        render: (item) => (
          <div>
            <Tooltip
              title={item && dayjs(item).format('YYYY年MM月DD日')}
              placement={'topLeft'}
            >
              {item && dayjs(item).format('YYYY年MM月DD日')}
            </Tooltip>
          </div>
        ),
      },
    ];
  }, [handleDownloadFile]);
  return (
    <AntdTable isLoading={false} columns={columns} dataSource={dataSource} />
  );
};

export default TableListFile;
